import auth from "@/plugins/auth";
import router, { constantRoutes, dynamicRoutes } from "@/router";
import { getRouters } from "@/api/menu";
import Layout from "@/layout/index";
import ParentView from "@/components/ParentView";
import InnerLink from "@/layout/components/InnerLink";
// 匹配views里面所有的.vue文件
const modules = require.context("@/views", true, /\.vue$/);
const usePermissionStore = defineStore("permission", {
  state: () => ({
    routes: [],
    addRoutes: [],
    defaultRoutes: [],
    topbarRouters: [],
    sidebarRouters: constantRoutes
  }),
  actions: {
    setRoutes(routes) {
      this.addRoutes = routes;
      this.routes = constantRoutes.concat(routes);
    },
    setDefaultRoutes(routes) {
      this.defaultRoutes = constantRoutes.concat(routes);
    },
    setTopbarRoutes(routes) {
      this.topbarRouters = routes;
    },
    setSidebarRouters(routes) {
      this.sidebarRouters = routes;
    },
    generateRoutes(roles) {
      return new Promise(resolve => {
        // const res = {data:mockData}
        //   console.log(res)
        // const sdata = JSON.parse(JSON.stringify(res.data));
        //   const rdata = JSON.parse(JSON.stringify(res.data));
        //   const defaultData = JSON.parse(JSON.stringify(res.data));
        //   const sidebarRoutes = filterAsyncRouter(sdata);
        //   const rewriteRoutes = filterAsyncRouter(rdata, false, true);
        //   const defaultRoutes = filterAsyncRouter(defaultData);
        //   const asyncRoutes = filterDynamicRoutes(dynamicRoutes);
        //   asyncRoutes.forEach(route => {
        //     router.addRoute(route);
        //   });
        //     this.setRoutes(rewriteRoutes);
        //   this.setSidebarRouters(constantRoutes.concat(sidebarRoutes));
        //   this.setDefaultRoutes(sidebarRoutes);
        //   this.setTopbarRoutes(defaultRoutes);
        //   resolve(rewriteRoutes);

        // console.log(constantRoutes,'constantRoutes')
        // this.setRoutes(constantRoutes);
        // this.setSidebarRouters(constantRoutes);
        // this.setDefaultRoutes(constantRoutes);
        // this.setTopbarRoutes(constantRoutes);
        // console.log(constantRoutes,'rewriteRoutes')
        // resolve(constantRoutes);
        // 向后端请求路由数据
        getRouters().then(res => {
          const sdata = JSON.parse(JSON.stringify(res.data));
          const rdata = JSON.parse(JSON.stringify(res.data));
          const defaultData = JSON.parse(JSON.stringify(res.data));
          const sidebarRoutes = filterAsyncRouter(sdata);
          const rewriteRoutes = filterAsyncRouter(rdata, false, true);
          const defaultRoutes = filterAsyncRouter(defaultData);
          const asyncRoutes = filterDynamicRoutes(dynamicRoutes);
          asyncRoutes.forEach(route => {
            router.addRoute(route);
          });
          this.setRoutes(rewriteRoutes);
          this.setSidebarRouters(constantRoutes.concat(sidebarRoutes));
          this.setDefaultRoutes(sidebarRoutes);
          this.setTopbarRoutes(defaultRoutes);
          resolve(rewriteRoutes);
        });
      });
    }
  }
});

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
  return asyncRouterMap.filter(route => {
    if (type && route.children) {
      route.children = filterChildren(route.children);
    }
    if (route.component) {
      // Layout ParentView 组件特殊处理
      if (route.component === "Layout") {
        route.component = Layout;
      } else if (route.component === "ParentView") {
        route.component = ParentView;
      } else if (route.component === "InnerLink") {
        route.component = InnerLink;
      } else {
        route.component = loadView(route.component);
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, route, type);
    } else {
      delete route["children"];
      delete route["redirect"];
    }
    return true;
  });
}
function filterChildren(childrenMap, lastRouter = false) {
  var children = [];
  childrenMap.forEach((el, index) => {
    if (el.children && el.children.length) {
      if (el.component === "ParentView" && !lastRouter) {
        el.children.forEach(c => {
          c.path = el.path + "/" + c.path;
          if (c.children && c.children.length) {
            children = children.concat(filterChildren(c.children, c));
            return;
          }
          children.push(c);
        });
        return;
      }
    }
    if (lastRouter) {
      el.path = lastRouter.path + "/" + el.path;
    }
    children = children.concat(el);
  });
  return children;
}

// 动态路由遍历，验证是否具备权限
export function filterDynamicRoutes(routes) {
  const res = [];
  routes.forEach(route => {
    if (route.permissions) {
      if (auth.hasPermiOr(route.permissions)) {
        res.push(route);
      }
    } else if (route.roles) {
      if (auth.hasRoleOr(route.roles)) {
        res.push(route);
      }
    }
  });
  return res;
}
export const loadView = view => {
  let res;
  modules.keys().filter(path => path.split("./")[1].split(".vue")[0] === view).forEach(path => {
    if (process.env.NODE_ENV === "development") {
      // res = (resolve) => require([`@/views/${view}`], resolve);
      res = () => modules(path);
    } else {
      // 使用 import 实现生产环境的路由懒加载
      res = () => import(`@/views/${view}`);
    }
  });
  return res;
};
export default usePermissionStore;